<template>
  <div id="bk_index" class="relativeItem biao_ke">
    <div class="main_top relativeItem">
      <img class="imgBlock noevents-img" src="../../assets/biao/toptu.png" />
      <!-- 顶部灯笼的动画 -->
      <div class="absoluteItem dltop1_box">
        <img
          class="imgBlock noevents-img"
          src="../../assets/biao/dltop01.png"
        />
      </div>
      <div class="absoluteItem dltop2_box">
        <img
          class="imgBlock noevents-img"
          src="../../assets/biao/dltop02.png"
        />
      </div>
      <div class="absoluteItem dltop3_box">
        <img
          class="imgBlock noevents-img"
          src="../../assets/biao/dltop03.png"
        />
      </div>

      <!--关闭页面的按钮-->
      <a class="close_img imgBlock" @click="close_web">
        <img
          src="../../assets/qixi/qixi(41).png"
          class="imgBlock noevents-img"
        />
      </a>
    </div>
    <div class="main_con">
      <div class="relativeItem">
        <img
          class="imgBlock noevents-img"
          src="../../assets/biao/bgimg01.png"
        />
        <div class="tit_con absoluteItem centerX">
          <img
            class="imgBlock noevents-img"
            src="../../assets/biao/bgtit.png"
          />
          <p class="absoluteItem tit_p">领取奖品</p>
        </div>
      </div>

      <div class="ct_main">
        <ul class="ul_div flex-box relativeItem">
          <li class="flex-box relativeItem" v-for="(n, i) in giftData" :key="i">
            <div class="name_g flex-box">{{ n.msg }}</div>
            <div class="gift_div">
              <img class="imgBlock noevents-img" :src="n.url" />
            </div>
          </li>
        </ul>

        <div class="ling_btn" @click="getGiftFun">{{ textGet }}</div>
      </div>
      <img class="imgBlock noevents-img" src="../../assets/biao/bgimg03.png" />
    </div>

    <div class="text_zb">活动最终解释权归朱贝平台所有</div>
  </div>
</template>








<script>
export default {
  name: "get_index",
  data() {
    return {
      textGet: "领取活动奖励",
      giftData: [],
      isGet: 1, // 大于0未领取  小于0已领取
    };
  },
  mounted() {
    this.$tool.setTitle("镖客行-奖励领取");
    this.getGiftList();
  },
  methods: {
    /**关闭webview */
    close_web() {
      if (this.$route.query.gobk == 1) {
        this.$router.go(-1);
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        //系统消息领奖进来的
        this.$appAc.closeWeb();
      }
    },

    // 获取中奖列表
    getGiftList() {
      let _this = this,
        data = {};
      this.$jsonp(this.$apis("award_list"), data, (res) => {
        if (res.data.ret == 1) {
          _this.giftData = res.data.data.data;
          this.isGet = res.data.data.is_settle;
          if (this.isGet < 0) {
            this.textGet = "已领取";
            document.querySelector(".ling_btn").style.opacity = ".5";
          }
        } else {
          _this.$tool.tipImg("您还未中奖~", "error");
        }
      });
    },

    // 领取奖励的操作
    getGiftFun() {
      if (this.textGet == "已领取") {
        return;
      } else {
        let _this = this,
          data = {};
        this.$jsonp(this.$apis("get_award"), data, (res) => {
          if (res.data.ret == 1) {
            document.querySelector(".ling_btn").classList.add("searBtn_ani");
            setTimeout(() => {
              document
                .querySelector(".ling_btn")
                .classList.remove("searBtn_ani");
            }, 500);
            _this.textGet = "已领取";
            _this.isGet = -1;
            document.querySelector(".ling_btn").style.opacity = ".5";
            _this.$tool.tipImg("领取成功", "success");
          } else {
            _this.$tool.tipImg(res.data.data, "error");
          }
        });
      }
    },
  },
  computed: {},
  watch: {},
};
</script>









<style scoped>
#bk_index {
  width: 100%;
  min-height: 100vh;
  background-color: #d3182b;
}
.close_img {
  position: fixed;
  width: 9%;
  top: 8%;
  z-index: 18;
}
.main_top {
  overflow: hidden;
}
/* 顶部灯笼的动画 */
.dltop1_box {
  top: -4px;
  left: -3px;
  width: 20%;
  transform-origin: left top;
  animation: bkDengAni01 1s linear infinite alternate;
}
.dltop1_box img {
  width: 100%;
}

.dltop2_box {
  top: -3px;
  right: 3%;
  width: 12%;
  transform-origin: right top;
  animation: bkDengAni02 1s linear 0.5s infinite alternate;
  z-index: 2;
}
.dltop2_box img {
  width: 100%;
}
.dltop3_box {
  top: -3px;
  right: -3px;
  width: 11%;
  transform-origin: right top;
  animation: bkDengAni03 1.3s linear infinite alternate;
}
.dltop3_box img {
  width: 100%;
}

.main_con {
  width: 100%;
  margin-top: -42px;
  position: relative;
  z-index: 2;
}
.tit_con {
  top: -26%;
}
.tit_con img {
  width: 115px;
  height: 30px;
}
.tit_con .tit_p {
  color: #fff;
  font-size: 13px;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.ct_main {
  min-height: 240px;
  background: url("../../assets/biao/bgimg02.png") repeat;
  background-size: 100% 100%;
}
.ul_div {
  width: 100%;
  padding: 30px 8% 0;
  justify-content: space-between;
}
.ul_div li {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #ffe5dc;
  border-radius: 12px;
  width: 28%;
}

.ul_div li:nth-child(1)::after {
  position: absolute;
  content: "+";
  color: #fa8283;
  font-size: 30px;
  top: 50%;
  transform: translateY(-50%);
  right: -23%;
  z-index: 3;
}
.ul_div li:nth-child(2)::after {
  position: absolute;
  content: "+";
  color: #fa8283;
  font-size: 30px;
  top: 50%;
  transform: translateY(-50%);
  right: -23%;
  z-index: 3;
}
.ul_div li:nth-child(4)::after {
  position: absolute;
  content: "+";
  color: #fa8283;
  font-size: 30px;
  top: 50%;
  transform: translateY(-50%);
  right: -23%;
  z-index: 3;
}
.ul_div li:nth-child(5)::after {
  position: absolute;
  content: "+";
  color: #fa8283;
  font-size: 30px;
  top: 50%;
  transform: translateY(-50%);
  right: -23%;
  z-index: 3;
}
.ul_div li .name_g {
  width: 100%;
  height: 43px;
  text-align: center;
  justify-content: center;
  align-items: center;
  background-color: #ff748a;
  color: #fff;
  font-size: 0.8125rem;
  padding: 0 3px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.gift_div {
  width: 100%;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.gift_div img {
  height: 68px;
  width: 68px;
  margin: 8px auto;
}
.ling_btn {
  width: 28%;
  text-align: center;
  padding: 8px 0;
  color: #fff;
  border-radius: 10px;
  font-size: 0.8125rem;
  background: -webkit-linear-gradient(top, #fb8a49, #f2492f);
  background: linear-gradient(to bottom, #fb8a49, #f2492f);
  margin: 40px auto 0;
}
.searBtn_ani {
  animation: bigBtnAni 0.2s linear;
}

/* 底部文字 */
.text_zb {
  width: 100%;
  text-align: center;
  color: #fff;
  font-size: 0.8125rem;
  padding: 18px 0;
}
</style>